import { css } from 'styled-components';

// Consumers add their own layout, sizing and overflow handling on top.
export const contentBlockSurface = css`
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(4)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};
`;
